import { RegistrationService } from './../../registration.service';
import { Component, OnInit } from '@angular/core';
import {BrowserModule} from '@angular/platform-browser'
import {Subject} from 'rxjs/Subject';
import { SainikSchemesModel,SainikSchemeApplicationModel} from './../../shared/user.model';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { Title } from '@angular/platform-browser/src/browser/title';
declare var $: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})

export class DashboardComponent implements OnInit {  
  id: number;
  formSubmitted: boolean;
  inputVar: string;
  SainikSchemesDetails:any={};
  itemsPerPage: number=5;
  currentPage: number=1;  
  totalItems: number;
  sainikSchemeApplicationModel : SainikSchemeApplicationModel;

  constructor(private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) 
  {

  }

  ngOnInit() {
    this.sainikSchemeApplicationModel = new SainikSchemeApplicationModel;
    this.GetAllSainikSchemes(this.itemsPerPage, 1);
  }

  openModalDialog(id,name) {
    $("#ApplicationForm").modal('show');
    this.EditDependents(id,name);

  }

  EditDependents(id,name) {
    debugger;      
    this.inputVar = name;
    this.id = id;    
    //this.fd['SD_Qualifictaion']=this.FamilyDetails[i].Qualifications.Q_Id;
    //   this.Removefamily(i);  
    //this.closeModalDialog();
  }

  closeModalDialog() {
    $("#ApplicationForm").modal('hide');
  }

  pageChanged(pageNumber:number)
  {    
    this.GetAllSainikSchemes(this.itemsPerPage, pageNumber);
  }
  
  itemsPerPageChanged(itemsPerPage: number, pageNo: number) 
  {    
    this.GetAllSainikSchemes(this.itemsPerPage, pageNo);
  }

  GetAllSainikSchemes(itemsPerPage: number, pageNo: number) 
  {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAllSainikSchemes(itemsPerPage,pageNo)
      .subscribe(
        (data:any) => {
          this.SainikSchemesDetails = data.SainikSchemesModels;
          this.totalItems=data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  SaveApplicationForm(form)
  {
    if (!form.invalid)
    {
      debugger;
      document.getElementById('loader-spinner').style.display = "block";
      this.sainikSchemeApplicationModel.Scheme_Id = this.id;
      this.userService.addApplicationForm(this.sainikSchemeApplicationModel).subscribe(
      (data:any) => {
        debugger;
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Application Form Submitted Successfully!','success');
        this.closeModalDialog();
        this.router.navigate(['/home/SchemesApplications']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });
    }
    else
    {
      this.formSubmitted = true;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/schemes/dashboard/dashboard.component.ts